import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

export function bind(eventType, eventData, handler) {
	if (typeof handler === 'function') {
		return $(window).bind(eventType, eventData, handler);
	} else {
		return $(window).bind(eventType, eventData);
	}
}

export function unbind(eventType, handler) {
	return $(window).unbind(eventType, handler);
}

export function trigger(eventType, extraParameters) {
	return $(window).trigger(eventType, extraParameters);
}
